import { Instance } from 'mobx-state-tree';
import { RouteReversingFailedDtoModelBase } from './RouteReversingFailedDtoModel.base';

/* The TypeScript type of an instance of RouteReversingFailedDtoModel */
export interface RouteReversingFailedDtoModelType extends Instance<typeof RouteReversingFailedDtoModel.Type> {}

/* A graphql query fragment builders for RouteReversingFailedDtoModel */
export { selectFromRouteReversingFailedDto, routeReversingFailedDtoModelPrimitives, RouteReversingFailedDtoModelSelector } from './RouteReversingFailedDtoModel.base';

/**
 * RouteReversingFailedDtoModel
 *
 * Route reversing failed event
 */
export const RouteReversingFailedDtoModel = RouteReversingFailedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
